import type { Metadata } from "next";
import ForgotPassword from "@/Component/Auth/ForgotPassword";

export const metadata: Metadata = {
    title: "Forgot Password | Connector Club",
    description: "",
};

const ForgotPasswordPage = () => {
    return (
        <ForgotPassword />
    )
}

export default ForgotPasswordPage
